import { Pipe, PipeTransform } from '@angular/core';
import { optionsUI } from 'src/app/utils/optionsUI';

@Pipe({
  name: 'distanceUnit',
})
export class DistanceUnitPipe implements PipeTransform {
  transform(value: string): string {
    return `${optionsUI.distanceUnits[value]?.display}s`;
  }
}
